// extracted by mini-css-extract-plugin
export default {"Contact":"ContactDark_Contact__3ksKS"};